'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var DEFAULT = 'https://cardshop.americanexpress.com';
var CONSUMER_API_PATH = 'api/acquisition/digital/v1/shop';
var CONSUMER_DEFAULT = 'https://acquisition.americanexpress.com/' + CONSUMER_API_PATH;

var gcsE3ApiHostNames = {
  'www.americanexpress.com': DEFAULT,
  'opengcp-fe1.americanexpress.com': DEFAULT,
  'opengcp-fe2.americanexpress.com': DEFAULT,
  'opengcp-fe-green1.americanexpress.com': DEFAULT,
  'opengcp-fe-green2.americanexpress.com': DEFAULT,
  'opengcp-fe.americanexpress.com': DEFAULT,
  'online.americanexpress.com': DEFAULT,
  'ipc1online.americanexpress.com': DEFAULT,
  'ipc2online.americanexpress.com': DEFAULT,

  // GCS V4
  'dacommercialfe1.americanexpress.com': 'https://dacommercialshop2.americanexpress.com',
  'dacommercialfe2.americanexpress.com': 'https://dacommercialshop2.americanexpress.com',
  'dacommercialfe-green-r2.americanexpress.com': 'https://dacommercialshop-green-r2.americanexpress.com',
  'dacommercialfe-r2.americanexpress.com': 'https://dacommercialshop-r2.americanexpress.com',
  'dacommercialfe-green1.americanexpress.com': 'https://dacommercialshop-green1.americanexpress.com',
  'dacommercialfe-green2.americanexpress.com': 'https://dacommercialshop-green2.americanexpress.com',

  // GCS Hydra Frontend pointing to eCP Backend
  'dacommercialfehydra.americanexpress.com': DEFAULT,
  'dacommercialfe-eusw1.americanexpress.com': 'https://dacommercialshop-eusw1.americanexpress.com',
  'dacommercialfe-euse1.americanexpress.com': 'https://dacommercialshop-euse1.americanexpress.com',
  'dacommercialfe-eusw1green.americanexpress.com': 'https://dacommercialshop-eusw1green.americanexpress.com',
  'dacommercialfe-euse1green.americanexpress.com': 'https://dacommercialshop-euse1green.americanexpress.com'
};

var gcsE3HostNames = Object.keys(gcsE3ApiHostNames);

var API_HOST_NAMES = _extends({
  // GCS
  '127.0.0.1': 'http://localhost:3000',
  localhost: 'http://localhost:3000',
  'www.vboxhost.com': 'http://localhost:3000',
  'opengcp-fe-dev.aexp.com': 'https://cardshop-dev.aexp.com',
  'opengcp-fe-dev.americanexpress.com': 'https://cardshop-dev.americanexpress.com',
  'opengcp-fe-green-qa.americanexpress.com': 'https://cardshop-green-qa.americanexpress.com',
  'opengcp-fe-qa.americanexpress.com': 'https://cardshop-qa.americanexpress.com',
  'qwww.americanexpress.com': 'https://cardshop-qa.americanexpress.com',
  'e2qonline.americanexpress.com': 'https://cardshop-qa.americanexpress.com'

}, gcsE3ApiHostNames, {
  // GCS V4 E1
  'gcsfe-dev.americanexpress.com': 'https://dacommerical-dev.americanexpress.com',
  'gcsfe1-dev.americanexpress.com': 'https://dacommercial1-dev.americanexpress.com',
  'gcsfe2-dev.americanexpress.com': 'https://dacommercial2-dev.americanexpress.com',
  'gcsfe3-dev.americanexpress.com': 'https://dacommercial3-dev.americanexpress.com',
  'gcsfe4-dev.americanexpress.com': 'https://dacommercial4-dev.americanexpress.com',

  // GCS ARENA
  'gcsarenafe-dev.americanexpress.com': 'https://gcsarenabe-dev.americanexpress.com',
  'gcsarenafe-qa.americanexpress.com': 'https://gcsarenabe-qa.americanexpress.com',

  // GCS V4 E2
  'gcsfe-qa.americanexpress.com': 'https://dacommerical-qa.americanexpress.com',
  'gcsfe1-qa.americanexpress.com': 'https://dacommercial1-qa.americanexpress.com',
  'gcsfe2-qa.americanexpress.com': 'https://dacommercial2-qa.americanexpress.com',
  'gcsfe3-qa.americanexpress.com': 'https://dacommercial3-qa.americanexpress.com',
  'gcsfe4-qa.americanexpress.com': 'https://dacommercial4-qa.americanexpress.com',
  'dacommercialfe-qa.americanexpress.com': 'https://dacommercialshop-qa.americanexpress.com',

  // GCS Hydra Frontend E1 & E2 pointing to eCP Backend
  'dacommercialfe-deveusw1.americanexpress.com': 'https://cardshop-dev.americanexpress.com',
  'dacommercialfe-qaeusw1.americanexpress.com': 'https://cardshop-qa.americanexpress.com',
  'dacommercialfe-qaeusw1green.americanexpress.com': 'https://cardshop-green-qa.americanexpress.com',
  'gcsfe1-deveusw1.americanexpress.com': 'https://dacommercial1-dev.americanexpress.com',
  'gcsfe1-qaeusw1.americanexpress.com': 'https://dacommercial1-qa.americanexpress.com',
  'gcsfe2-deveusw1.americanexpress.com': 'https://dacommercial2-dev.americanexpress.com',
  'gcsfe2-qaeusw1.americanexpress.com': 'https://dacommercial2-qa.americanexpress.com',
  'gcsfe3-deveusw1.americanexpress.com': 'https://dacommercial3-dev.americanexpress.com',
  'gcsfe3-qaeusw1.americanexpress.com': 'https://dacommercial3-qa.americanexpress.com',
  'gcsfe4-deveusw1.americanexpress.com': 'https://dacommercial4-dev.americanexpress.com',
  'gcsfe4-qaeusw1.americanexpress.com': 'https://dacommercial4-qa.americanexpress.com',
  'gcsfe-deveusw1.americanexpress.com': 'https://dacommerical-dev.americanexpress.com',
  'gcsfe-qaeusw1.americanexpress.com': 'https://dacommerical-qa.americanexpress.com',
  'gcsarenafe-deveusw1.americanexpress.com': 'https://gcsarenabe-deveusw1.americanexpress.com',
  'gcsarenafe-qaeusw1.americanexpress.com': 'https://gcsarenabe-qaeusw1.americanexpress.com',

  // E1 cps
  'acquisition-dev.americanexpress.com': 'https://acquisition-dev.americanexpress.com/' + CONSUMER_API_PATH,
  'acquisition-1-dev.americanexpress.com': 'https://acquisition-1-dev.americanexpress.com/' + CONSUMER_API_PATH,
  'acquisition-2-dev.americanexpress.com': 'https://acquisition-2-dev.americanexpress.com/' + CONSUMER_API_PATH,
  'acquisition-3-dev.americanexpress.com': 'https://acquisition-3-dev.americanexpress.com/' + CONSUMER_API_PATH,
  'acquisition-4-dev.americanexpress.com': 'https://acquisition-4-dev.americanexpress.com/' + CONSUMER_API_PATH,
  'acquisition-5-dev.americanexpress.com': 'https://acquisition-5-dev.americanexpress.com/' + CONSUMER_API_PATH,
  'acquisition-6-dev.americanexpress.com': 'https://acquisition-6-dev.americanexpress.com/' + CONSUMER_API_PATH,
  'acquisition-7-dev.americanexpress.com': 'https://acquisition-7-dev.americanexpress.com/' + CONSUMER_API_PATH,
  'acquisition-9-dev.americanexpress.com': 'https://acquisition-9-dev.americanexpress.com/' + CONSUMER_API_PATH,
  'acquisition-10-dev.americanexpress.com': 'https://acquisition-10-dev.americanexpress.com/' + CONSUMER_API_PATH,

  // E2 cps
  'acquisition-green-qa.americanexpress.com': 'https://acquisition-green-qa.americanexpress.com/' + CONSUMER_API_PATH,
  'acquisition-1-green-qa.americanexpress.com': 'https://acquisition-1-green-qa.americanexpress.com/' + CONSUMER_API_PATH,
  'acquisition-2-green-qa.americanexpress.com': 'https://acquisition-2-green-qa.americanexpress.com/' + CONSUMER_API_PATH,
  'acquisition-3-green-qa.americanexpress.com': 'https://acquisition-3-green-qa.americanexpress.com/' + CONSUMER_API_PATH,
  'acquisition-4-green-qa.americanexpress.com': 'https://acquisition-4-green-qa.americanexpress.com/' + CONSUMER_API_PATH,
  'acquisition-5-green-qa.americanexpress.com': 'https://acquisition-5-green-qa.americanexpress.com/' + CONSUMER_API_PATH,
  'acquisition-6-green-qa.americanexpress.com': 'https://acquisition-6-green-qa.americanexpress.com/' + CONSUMER_API_PATH,
  'acquisition-7-green-qa.americanexpress.com': 'https://acquisition-7-green-qa.americanexpress.com/' + CONSUMER_API_PATH,
  'acquisition-9-green-qa.americanexpress.com': 'https://acquisition-9-green-qa.americanexpress.com/' + CONSUMER_API_PATH,
  'acquisition-10-green-qa.americanexpress.com': 'https://acquisition-10-green-qa.americanexpress.com/' + CONSUMER_API_PATH,
  'acquisition-qa.americanexpress.com': 'https://acquisition-qa.americanexpress.com/' + CONSUMER_API_PATH,
  'acquisition-1-qa.americanexpress.com': 'https://acquisition-1-qa.americanexpress.com/' + CONSUMER_API_PATH,
  'acquisition-2-qa.americanexpress.com': 'https://acquisition-2-qa.americanexpress.com/' + CONSUMER_API_PATH,
  'acquisition-3-qa.americanexpress.com': 'https://acquisition-3-qa.americanexpress.com/' + CONSUMER_API_PATH,
  'acquisition-4-qa.americanexpress.com': 'https://acquisition-4-qa.americanexpress.com/' + CONSUMER_API_PATH,
  'acquisition-5-qa.americanexpress.com': 'https://acquisition-5-qa.americanexpress.com/' + CONSUMER_API_PATH,
  'acquisition-6-qa.americanexpress.com': 'https://acquisition-6-qa.americanexpress.com/' + CONSUMER_API_PATH,
  'acquisition-7-qa.americanexpress.com': 'https://acquisition-7-qa.americanexpress.com/' + CONSUMER_API_PATH,
  'acquisition-9-qa.americanexpress.com': 'https://acquisition-9-qa.americanexpress.com/' + CONSUMER_API_PATH,
  'acquisition-10-qa.americanexpress.com': 'https://acquisition-10-qa.americanexpress.com/' + CONSUMER_API_PATH,

  // E3 cps
  'acquisition.americanexpress.com': 'https://acquisition-1.americanexpress.com/' + CONSUMER_API_PATH
});

var CONSUMER_HOST_NAMES = _extends({}, API_HOST_NAMES, { 'qwww.americanexpress.com': 'https://acquisition-1-qa.americanexpress.com/' + CONSUMER_API_PATH, 'www.americanexpress.com': 'https://acquisition-1.americanexpress.com/' + CONSUMER_API_PATH });

var getApiHost = exports.getApiHost = function getApiHost(siteHost, shop) {
  if (!siteHost) {
    return DEFAULT;
  }

  var host = siteHost.split(':')[0];

  if (shop === 'consumer') {
    return CONSUMER_HOST_NAMES[host] || CONSUMER_DEFAULT;
  }

  return API_HOST_NAMES[host] || DEFAULT;
};

var e3HostsByShop = {
  gcs: gcsE3HostNames,
  cps: [] // cps to be added here later
};

var getE3HostNames = exports.getE3HostNames = function getE3HostNames(shop) {
  if (e3HostsByShop[shop]) return e3HostsByShop[shop];

  console.error('Shop param not valid, must be gcs || cps'); // eslint-disable-line no-console
  return [];
};